import { Routes } from '@angular/router';
import { accountGuard } from '@domain/guards/account.guard';
import { authGuard } from '@domain/guards/auth.guard';

export const routes: Routes = [
  {
    // canActivate here would never run -- Angular's router resolves
    // redirectTo before activation, so the guard on this entry was dead
    // code, and combining the two throws NG04014 (invalid route config)
    // as soon as the Router is constructed, breaking every route on every
    // `ng serve`. Protection already exists independently on 'dashboard'
    // below (same authGuard), which is what actually gates this redirect's
    // destination.
    path: '',
    redirectTo: 'dashboard/home',
    pathMatch: 'full',
  },
  {
    path: 'login',
    loadComponent: () => import('@uiViews/member-portal/member-portal-container.component').then((m) => m.MemberPortalContainerComponent),
    data: { title: 'Login' },
    canActivate: [accountGuard],
  },
  {
    path: 'forgot-password',
    loadComponent: () => import('@uiViews/member-portal/user/forgot-password/forgot-password.component').then((m) => m.ForgotPasswordComponent),
    data: { title: 'Forgot Password' },
    canActivate: [accountGuard],
  },
  {
    path: 'set-password',
    loadComponent: () => import('@uiViews/member-portal/user/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
    data: { title: 'Create Password', mode: 'set' },
    canActivate: [accountGuard],
  },
  {
    path: 'reset-password',
    loadComponent: () => import('@uiViews/member-portal/user/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
    data: { title: 'Reset Password', mode: 'reset' },
    canActivate: [accountGuard],
  },
  {
    // Links already in inboxes carry the token in the path.
    path: 'reset-password/:token',
    loadComponent: () => import('@uiViews/member-portal/user/reset-password/reset-password.component').then((m) => m.ResetPasswordComponent),
    data: { title: 'Reset Password' },
    canActivate: [accountGuard],
  },
  {
    path: 'dashboard',
    loadChildren: () => import('@uiViews/member-portal/dashboard/dashboard.routes').then((m) => m.routes),
    canActivate: [authGuard],
  },
  {
    path: '**',
    redirectTo: '/login',
    pathMatch: 'full',
  },
];
